var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 890 188",
    style: {
      enableBackground: "new 0 0 890 188"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E3785;}\n\t.st1{fill:#5CC13E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M283.05,17.05L283.05,17.05c15.51,7.11,21.79,24.41,14.04,38.63l-55.63,102.06 c-7.75,14.22-26.61,19.99-42.11,12.88h0c-15.51-7.11-21.79-24.41-14.04-38.63l55.63-102.06C248.69,15.7,267.55,9.93,283.05,17.05z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.65,17.05L183.65,17.05c15.51,7.11,21.79,24.41,14.04,38.63l-55.63,102.06 c-7.75,14.22-26.61,19.99-42.11,12.88h0c-15.51-7.11-21.79-24.41-14.04-38.63l55.63-102.06C149.29,15.7,168.14,9.93,183.65,17.05z "
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 52.85,
    cy: 55.44,
    rx: 41.85,
    ry: 38.39
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M325.55,96.39c0-20.09,15.65-34.96,36.99-34.96c21.25,0,36.99,14.78,36.99,34.96c0,20.19-15.74,34.96-36.99,34.96 C341.2,131.35,325.55,116.48,325.55,96.39z M383.7,96.39c0-12.85-9.08-21.64-21.15-21.64s-21.15,8.79-21.15,21.64 c0,12.85,9.08,21.64,21.15,21.64S383.7,109.23,383.7,96.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.74,87.11c0,15.07-11.3,24.44-29.36,24.44h-13.62v18.64h-15.65V62.58h29.27C464.44,62.58,475.74,71.95,475.74,87.11z  M459.9,87.11c0-7.44-4.83-11.78-14.39-11.78h-12.75V98.8h12.75C455.07,98.8,459.9,94.45,459.9,87.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.27,87.11c0,15.07-11.3,24.44-29.36,24.44h-13.62v18.64h-15.65V62.58h29.27C539.97,62.58,551.27,71.95,551.27,87.11z  M535.43,87.11c0-7.44-4.83-11.78-14.39-11.78h-12.75V98.8h12.75C530.6,98.8,535.43,94.45,535.43,87.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.82,123.53l5.31-11.78c5.7,4.15,14.2,7.05,22.31,7.05c9.27,0,13.04-3.09,13.04-7.24c0-12.65-39.31-3.96-39.31-29.07 c0-11.49,9.27-21.06,28.49-21.06c8.5,0,17.19,2.03,23.47,5.99l-4.83,11.88c-6.28-3.57-12.75-5.31-18.74-5.31 c-9.27,0-12.85,3.48-12.85,7.73c0,12.46,39.31,3.86,39.31,28.69c0,11.3-9.37,20.96-28.69,20.96 C580.63,131.35,569.81,128.16,563.82,123.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.36,62.58l-22.79,67.61h-7.53l-19.8-57.66l-19.9,57.66h-7.44l-22.79-67.61h7.34l19.51,58.15l20.19-58.15h6.66 l19.9,58.44l19.8-58.44H732.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.12,106.91h-42.5c0.77,10.62,8.89,17.68,19.99,17.68c6.18,0,11.69-2.22,15.55-6.66l3.86,4.44 c-4.54,5.41-11.59,8.31-19.61,8.31c-15.84,0-26.66-10.82-26.66-25.89c0-15.07,10.53-25.79,24.82-25.79 c14.29,0,24.63,10.53,24.63,25.79C790.21,105.37,790.12,106.14,790.12,106.91z M747.62,101.8h36.03 c-0.87-9.95-8.11-16.9-18.06-16.9C755.73,84.89,748.49,91.85,747.62,101.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.01,58.52h6.86v71.67h-6.86V58.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.79,58.52h6.86v71.67h-6.86V58.52z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.8e280389ab0841f510c8d08c47c38004.svg";
export { ForwardRef as ReactComponent };